import React from 'react';
import { Row, Col, Breadcrumb } from 'antd';

const Dashboard = () => {
  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Dashboard" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">This is dashboard</div>
      </Col>
    </Row>
  );
};

export default Dashboard;
